import * as React from "react"

import { cn } from "@/shared/lib/utils"

interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
	/** Карточка реагирует на тап: подсветка рамки и лёгкое вдавливание. */
	interactive?: boolean
}

const Card = React.forwardRef<HTMLDivElement, CardProps>(
	({ className, interactive = false, ...props }, ref) => (
		<div
			ref={ref}
			className={cn(
				"rounded-2xl border border-border bg-card text-card-foreground",
				interactive &&
					"transition-[transform,border-color,background-color] duration-150 ease-[var(--ease-out-soft)] active:scale-[0.985] active:border-primary/30",
				className,
			)}
			{...props}
		/>
	),
)
Card.displayName = "Card"

const CardHeader = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
	({ className, ...props }, ref) => (
		<div ref={ref} className={cn("flex flex-col space-y-1.5 p-6", className)} {...props} />
	),
)
CardHeader.displayName = "CardHeader"

const CardTitle = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
	({ className, ...props }, ref) => (
		<div
			ref={ref}
			className={cn("font-semibold leading-none tracking-tight", className)}
			{...props}
		/>
	),
)
CardTitle.displayName = "CardTitle"

const CardDescription = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
	({ className, ...props }, ref) => (
		<div ref={ref} className={cn("text-sm text-muted-foreground", className)} {...props} />
	),
)
CardDescription.displayName = "CardDescription"

const CardContent = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
	({ className, ...props }, ref) => (
		<div ref={ref} className={cn("p-6 pt-0", className)} {...props} />
	),
)
CardContent.displayName = "CardContent"

const CardFooter = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
	({ className, ...props }, ref) => (
		<div ref={ref} className={cn("flex items-center p-6 pt-0", className)} {...props} />
	),
)
CardFooter.displayName = "CardFooter"

export { Card, type CardProps, CardHeader, CardFooter, CardTitle, CardDescription, CardContent }
